import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import FileIcon from "./FileIcon";
import { useDispatch, useSelector } from "react-redux";
import folder from "../../../../assets/svg/folder.svg";
// import { setCurrentPath } from "../../../../redux/action/Action";
import document from "../../../../assets/svg/documentActive.svg";
import Breadcrumbs from "../BreadGrumbs";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { setCategoryData } from "../../../../redux/action/Action";
import { POST_CATEGORIES } from "../../../../helpers/endpointService";
import Select from "react-select";
import arrowright from "../../../../assets/svg/arrow-right.svg";
import arrowleft from "../../../../assets/svg/arrow-left.svg";
import { ToastContainer, toast } from "react-toastify";
import Pagination from "../Pagination";
import { PulseLoader } from "react-spinners";
import PaginationComponent from "../Pagination";
import { logoutFunction } from "../../../custom/commonFunction";

export default function Folder() {
  const location = useLocation();
  const { category1Id } = useParams();
  const nav = useNavigate();
  const dispatch = useDispatch();
  const [isLoader, setLoader] = useState(false);
  let { documentList, menuToggle } = useSelector((state) => ({
    documentList: state.documentReducer.document,
    menuToggle: state.commonReducer.menuToggle,
  }));
  const [category1, setCategory1] = useState();
  const [category2, setCategory2] = useState();
  const [pageCount, setPageCount] = useState(1);
  const [isMobile, setisMobile] = useState(false);
  const [iswebMobile, setWebMobile] = useState(false);
  const paginglist = [
    { label: "5", value: 5 },
    { label: "10", value: 10 },
    { label: "20", value: 20 },
    { label: "50", value: 50 },
  ];
  const paginglistDefault = [{ label: "20", value: 20 }];

  useEffect(() => {
    if (documentList) {
      setCategory1(
        documentList?.values?.find(
          (li) => li.category1Id === parseInt(category1Id)
        )
      );
    } else {
      fetchCategory2(1, 20);
    }
  }, [documentList]);

  useEffect(() => {
    setCategory2(category1?.category2);
  }, [category1]);

  useEffect(() => {
    const intervals = setInterval(() => {
      resize();
    }, 10);
    return () => clearInterval(intervals);
  });

  const resize = () => {
    if (window.innerWidth < 850) {
      setisMobile(true);
    } else {
      setisMobile(false);
    }

    if (window.innerWidth < 400) {
      setWebMobile(true);
    } else {
      setWebMobile(false);
    }
  };

  ////////////// fetch  category 2 ///////////////
  const fetchCategory2 = async (currentpage, perpage) => {
    setLoader(true);
    let apiUrl = `${POST_CATEGORIES}?category1Id=${category1Id}`;
    const pageDetails = {
      pageNumber: currentpage,
      pageSize: perpage,
    };

    axios({
      method: "POST",
      url: apiUrl,
      data: pageDetails,
    })
      .then((response) => {
        if (response?.status === 200) {
          setLoader(false);
          setPageCount(response.data.totalCount);
          setCategory2(response.data?.values);
        }
      })
      .catch((err) => {
        setLoader(false);
        logoutFunction(err?.response?.status);
      });
  };

  const handleClick = (id) => {
    nav(`${id}`);
  };

  return (
    <>
      <ToastContainer
        limit={1}
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      {isLoader && (
        <div className="spinner_overlay">
          <div className="loader">
            <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
          </div>
        </div>
      )}

      <div className="titleContainer">
        <div className="title">
          <img src={document} />
          <span>Documents</span>
        </div>
        <Breadcrumbs location={location} />
      </div>

      {category2?.length > 0 ? (
        <div
          className="fileList"
          style={{ marginTop: isMobile ? "120px" : "122px" }}
        >
          <table className="fileListTable">
            <thead>
              <tr>
                <td>
                  <div>
                    <span>Name</span>
                  </div>
                </td>
              </tr>
            </thead>

            <tbody>
              {category2?.map((list, index) => {
                return (
                  <tr
                    key={index}
                    onClick={() =>
                      handleClick(list.category2Id, list.category2Name)
                    }
                  >
                    <td>
                      <img src={folder} alt="" />{" "}
                      <span>{list.category2Name}</span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <>
          <span className="empty">{category1 && "Folder is empty"}</span>
        </>
      )}
      {category2?.length > 0 && (
        <PaginationComponent
          fetchPagination={fetchCategory2}
          pageCount={pageCount}
        />
      )}
    </>
  );
}
